import {
  SourceType,
  useGetDexcomRedirectURL,
  useGetTandemRedirectURL,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useToasterContext } from "@tandemdiabetes/sugarmate-react-components"
import { useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"
import { useIsOnboardingSource } from "src/hooks"
import { AddSourceErrorToast } from "src/toasts"

export function useAddDataSource(isOnboarding?: boolean) {
  const getDexcomRedirectURL = useGetDexcomRedirectURL()
  const getTandemRedirectURL = useGetTandemRedirectURL()
  const [
    ,
    setIsOnboardingSource,
  ] = useIsOnboardingSource()

  const { showToast } = useToasterContext()
  const navigate = useNavigate()

  return useCallback(
    (sourceType: SourceType) => {
      if (sourceType === SourceType.Nightscout) {
        void navigate({
          to: isOnboarding ? "/onboarding/data_source/nightscout" : "/account/data_source/nightscout",
        })
      } else if (sourceType === SourceType.Tandem) {
        void (async () => {
          try {
            if (!getTandemRedirectURL) {
              throw new Error("cannot get redirect URL")
            }

            const response = await getTandemRedirectURL()

            if (isOnboarding) {
              // save a value in local storage that tells us to resume onboarding after tandem redirects
              setIsOnboardingSource(true)
            }

            // redirect to tandem
            location.assign(response.data.redirect_url)
          } catch {
            showToast(
              "add-tandem-source-error-toast",
              AddSourceErrorToast,
            )
          }
        })()
      } else {
        void (async () => {
          try {
            if (!getDexcomRedirectURL) {
              throw new Error("cannot get redirect URL")
            }

            const response = await getDexcomRedirectURL()

            if (isOnboarding) {
              // save a value in local storage that tells us to resume onboarding after dexcom redirects
              setIsOnboardingSource(true)
            }

            // redirect to dexcom
            location.assign(response.data.redirect_url)
          } catch {
            showToast(
              "add-dexcom-source-error-toast",
              AddSourceErrorToast,
            )
          }
        })()
      }
    },
    [
      navigate,
      getTandemRedirectURL,
      isOnboarding,
      setIsOnboardingSource,
      showToast,
      getDexcomRedirectURL,
    ],
  )
}
